import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, Typography } from '@mui/material';

import { OfferingDocument } from '@arrived/models';

import { PropertyDetailsList } from '../PropertyDetailsList';
import { YearSelect } from './YearSelect';

import { documentsConfig } from '../config/documentsConfig';

export interface PropertyDetailsFinancialsProps {
  financialDocuments: OfferingDocument[];
}

export const PropertyDetailsFinancials = ({ financialDocuments }: PropertyDetailsFinancialsProps) => {
  const yearList = useMemo(
    () => Array.from(new Set(financialDocuments.map((document) => document.year).filter(Boolean) as number[])).sort(),
    [financialDocuments]
  );

  const [selectedYear, setSelectedYear] = useState<number>(yearList[yearList.length - 1]);

  const yearDocuments = useMemo(
    () => financialDocuments.filter((document) => document.year === selectedYear),
    [financialDocuments, selectedYear]
  );

  if (!financialDocuments.length) return null;

  return (
    <Box display="flex">
      {yearDocuments && yearDocuments.length > 0 && (
        <PropertyDetailsList listData={documentsConfig(yearDocuments)}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h5.semibold">
              <FormattedMessage
                id="property-details-offering-financial-documents-title"
                defaultMessage="{year} Financial Statements"
                values={{ year: selectedYear }}
              />
            </Typography>
            <YearSelect onChange={setSelectedYear} selectableYears={yearList} value={selectedYear} />
          </Box>
        </PropertyDetailsList>
      )}
    </Box>
  );
};
